/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const black = "#000000";
const white = "#FFFFFF";
const overlay = "#1F2733";
/**
 * Base Palo Color Palette Scales
 */
const grayScale = {
    DEFAULT: "#B8B8B8",
    50: "#F9F9F9",
    100: "#F4F5F5",
    200: "#EAEBEB",
    300: "#DADBDB",
    400: "#B8B8B8",
    500: "#929191",
    600: "#707070",
    700: "#575757",
    800: "#484848",
    900: "#333333",
    950: "#242424",
    1000: "#1A1A1A",
    1050: "#0D0D0D",
};
const redScale = {
    DEFAULT: "#E14E4E",
    100: "#FCD4D4",
    200: "#FBBBBB",
    300: "#F59999",
    400: "#EE7272",
    500: "#E14E4E",
    600: "#B22D2D",
    700: "#891A1A",
    800: "#6C0F0F",
    900: "#530909",
    1000: "#320606",
};
const orangeScale = {
    DEFAULT: "#F38C16",
    100: "#FEE5C7",
    200: "#FDCF9B",
    300: "#FCB769",
    400: "#F38C16",
    500: "#CC7410",
    600: "#9D5707",
    700: "#764105",
    800: "#532E03",
    900: "#3B2102",
    1000: "#271602",
};
const yellowScale = {
    DEFAULT: "#FAD957",
    100: "#FFF4C7",
    200: "#FFEB99",
    300: "#FAD957",
    400: "#EBBE0A",
    500: "#BA9608",
    600: "#846B06",
    700: "#624F04",
    800: "#453703",
    900: "#312802",
    1000: "#221C01",
};
const tealScale = {
    DEFAULT: "#33CCB8",
    100: "#C5F9F2",
    200: "#A6F2E8",
    300: "#8AE2D6",
    400: "#33CCB8",
    500: "#29A393",
    600: "#137669",
    700: "#095349",
    800: "#073C35",
    900: "#052E28",
    1000: "#04201C",
};
const blueScale = {
    DEFAULT: "#38A5FF",
    100: "#EFF8FF",
    200: "#CFE8FC",
    300: "#85C8FF",
    400: "#38A5FF",
    500: "#128DF2",
    600: "#006FCC",
    700: "#004C9D",
    800: "#003474",
    900: "#00265B",
    1000: "#001533",
};
const blueSteelScale = {
    DEFAULT: "#9AA5B2",
    100: "#F0F4F7",
    200: "#DFE5EB",
    300: "#B8C1CC",
    400: "#9AA5B2",
    500: "#768494",
    600: "#5D6A7A",
    700: "#475566",
    800: "#354252",
    900: "#19222E",
    950: "#10171F",
    1000: "#0B1117",
};
/**
 * Additional Data Vis Color Palette Scales
 */
const limeScale = {
    DEFAULT: "#A2D80E",
    100: "#EEFEC2",
    200: "#DEFA91",
    300: "#C3F342",
    400: "#A2D80E",
    500: "#89B80A",
    600: "#5B7906",
    700: "#425705",
    800: "#2F3F03",
    900: "#212C02",
    1000: "#161D02",
};
const greenScale = {
    DEFAULT: "#1AA33E",
    100: "#CFFCDB",
    200: "#ABF8BF",
    300: "#84EBA0",
    400: "#50D975",
    500: "#1AA33E",
    600: "#1A7F34",
    700: "#0C5A21",
    800: "#074016",
    900: "#052E10",
    1000: "#04200C",
};
const cyanScale = {
    DEFAULT: "#76D6F9",
    100: "#CCF1FF",
    200: "#AFE9FD",
    300: "#76D6F9",
    400: "#3EBEED",
    500: "#289EC9",
    600: "#0A749B",
    700: "#044E69",
    800: "#03374A",
    900: "#022B3B",
    1000: "#021D27",
};
const skyScale = {
    DEFAULT: "#4290F5",
    100: "#D3E5FD",
    200: "#BAD7FD",
    300: "#8EBDFB",
    400: "#5FA1F7",
    500: "#4290F5",
    600: "#1C65C4",
    700: "#0E438A",
    800: "#063066",
    900: "#05244D",
    1000: "#031833",
};
const indigoScale = {
    DEFAULT: "#3F52D5",
    100: "#D8DDFD",
    200: "#CAD0FC",
    300: "#A0ACF8",
    400: "#7F8EF5",
    500: "#6073EB",
    600: "#3F52D5",
    700: "#253498",
    800: "#132176",
    900: "#0C165A",
    1000: "#070E40",
};
const purpleScale = {
    DEFAULT: "#9460DC",
    100: "#E7D8FD",
    200: "#D9C1FA",
    300: "#BF98F6",
    400: "#A97AEB",
    500: "#9460DC",
    600: "#763CC8",
    700: "#521F99",
    800: "#3A1173",
    900: "#2B0A57",
    1000: "#1E0642",
};
const pinkScale = {
    DEFAULT: "#E250BB",
    100: "#FDD1F1",
    200: "#FBB6E9",
    300: "#F58AD8",
    400: "#EA66C7",
    500: "#E250BB",
    600: "#B82E93",
    700: "#7C1861",
    800: "#5B0B46",
    900: "#410631",
    1000: "#2F0423",
};
const magentaScale = {
    DEFAULT: "#BC246A",
    100: "#FDD1E5",
    200: "#FBBBD8",
    300: "#F792C0",
    400: "#ED6EA7",
    500: "#DF498D",
    600: "#BC246A",
    700: "#811345",
    800: "#5C0A2F",
    900: "#450823",
    1000: "#2F0417",
};
/**
 * Sequential Multi-Hue Color Scales
 */
const redYellowScale = {
    100: "#FFF4C7",
    200: "#FFEB99",
    300: "#FFDC52",
    400: "#FFC73F",
    500: "#FFA722",
    600: "#FF8D0A",
    700: "#F77619",
    800: "#EC5A2C",
    900: "#E13D3D",
    1000: "#CD3636",
    1100: "#B22D2D",
    1200: "#9D2424",
    1300: "#891A1A",
    1400: "#6E1414",
    1500: "#530909",
    1600: "#320606",
};
const purpleMagentaScale = {
    100: "#FFF4C7",
    200: "#F9D1BF",
    300: "#F3A5AF",
    400: "#ED82A3",
    500: "#E75D96",
    600: "#E3458D",
    700: "#C83E90",
    800: "#AF3892",
    900: "#953194",
    1000: "#7E2B96",
    1100: "#642498",
    1200: "#521F99",
    1300: "#42187E",
    1400: "#37136C",
    1500: "#2B0C56",
    1600: "#1E0642",
};
const skyTealScale = {
    100: "#FFF4C7",
    200: "#CFEBC4",
    300: "#AAE4C1",
    400: "#8DDEBF",
    500: "#66D6BC",
    600: "#33CCB8",
    700: "#30BDBA",
    800: "#2CAABD",
    900: "#2899BF",
    1000: "#2487C1",
    1100: "#2075C3",
    1200: "#1C65C4",
    1300: "#1652A0",
    1400: "#103E7A",
    1500: "#092952",
    1600: "#031833",
};
/**
 * Divergent Color Scales
 */
const skyRedScale = {
    100: "#4E0E0E",
    200: "#731A19",
    300: "#9A2E2B",
    400: "#CE4844",
    500: "#E76057",
    600: "#ED8876",
    700: "#F4AD91",
    800: "#FAD4AF",
    900: "#FFF4C7",
    1000: "#C8DACD",
    1100: "#94C1D2",
    1200: "#5EA7D7",
    1300: "#1E88DD",
    1400: "#0F72C6",
    1500: "#0B5193",
    1600: "#083A6E",
    1700: "#06254D",
    1800: "#1A1A1A",
};
const indigoMagentaScale = {
    100: "#580C2E",
    200: "#74113E",
    300: "#9D2359",
    400: "#C23571",
    500: "#D74781",
    600: "#E47F99",
    700: "#ECA2AB",
    800: "#F2CED1",
    900: "#F4E5E6",
    1000: "#D3CEE2",
    1100: "#A6ADDE",
    1200: "#7D8BE6",
    1300: "#5A6ADD",
    1400: "#3F53D1",
    1500: "#2D3EAB",
    1600: "#1C2B87",
    1700: "#0F1C6B",
    1800: "#1A1A1A",
};
const tealOrangeScale = {
    100: "#563004",
    200: "#6F3E07",
    300: "#8E500A",
    400: "#AD620D",
    500: "#CA7310",
    600: "#D9933C",
    700: "#E6B56D",
    800: "#F3D59B",
    900: "#FFF4C7",
    1000: "#CCE1BB",
    1100: "#96CCAE",
    1200: "#5EB7A0",
    1300: "#279D8D",
    1400: "#1F8375",
    1500: "#17665C",
    1600: "#0E4941",
    1700: "#07342D",
    1800: "#1A1A1A",
};
const purpleTealScale = {
    100: "#07342D",
    200: "#0E4941",
    300: "#17665C",
    400: "#1F8375",
    500: "#279D8D",
    600: "#5EB7A0",
    700: "#96CCAE",
    800: "#CCE1BB",
    900: "#FFF4C7",
    1000: "#E1CCC8",
    1100: "#BE9DC8",
    1200: "#A277C8",
    1300: "#844EC8",
    1400: "#6A34B5",
    1500: "#562797",
    1600: "#441B7C",
    1700: "#2F0D5D",
    1800: "#1A1A1A",
};
/**
 * Vis Scale A - E will be deprecated
 */
const visScaleA = {
    100: "#303866",
    200: "#4E296C",
    300: "#742D7D",
    400: "#903280",
    500: "#A22C75",
    600: "#CA386A",
    700: "#EB5757",
};
const visScaleB = {
    100: "#661300",
    200: "#A62F0C",
    300: "#D95221",
    400: "#FF7B41",
    500: "#FF9A42",
    600: "#FFC74F",
    700: "#FFDE65",
};
const visScaleC = {
    100: "#1D7918",
    200: "#088D10",
    300: "#3EAE15",
    400: "#81C42E",
    500: "#AFD620",
    600: "#D6E31B",
    700: "#FFDE65",
};
const visScaleD = {
    100: "#357387",
    200: "#45959A",
    300: "#49A392",
    400: "#28C2A6",
    500: "#3ED6BA",
    600: "#7CE9CC",
    700: "#C5F5E9",
};
const visScaleE = {
    100: "#282F78",
    200: "#26418D",
    300: "#1F75B2",
    400: "#2C95C7",
    500: "#5DB8E4",
    600: "#7AC8ED",
    700: "#BCE4FA",
};
const error = {
    DEFAULT: redScale[500],
    light: redScale[300],
    lighter: redScale[200],
    lightest: redScale[100],
    dark: redScale[700],
    darker: redScale[800],
    darkest: redScale[900],
};
const warning = {
    DEFAULT: orangeScale[400],
    light: orangeScale[300],
    lighter: orangeScale[200],
    lightest: orangeScale[100],
    dark: orangeScale[700],
    darker: orangeScale[800],
    darkest: orangeScale[900],
};
const success = {
    DEFAULT: tealScale[400],
    light: tealScale[300],
    lighter: tealScale[200],
    lightest: tealScale[100],
    dark: tealScale[700],
    darker: tealScale[800],
    darkest: tealScale[900],
};
const primary = {
    DEFAULT: blueScale[400],
    light: blueScale[300],
    lighter: blueScale[200],
    lightest: blueScale[100],
};
/**
 * Low, Medium and High will be deprecated
 */
const severityColors = {
    critical: redScale[600],
    error: redScale[500],
    warning: orangeScale[400],
    caution: yellowScale[300],
    confirmation: tealScale[400],
    blocker: pinkScale[700],
    low: yellowScale[300],
    medium: orangeScale[400],
    high: redScale[500],
};
const riskColors = {
    "1": blueScale[300],
    pass: blueScale[300],
    "2": tealScale[400],
    warning: yellowScale[300],
    "3": yellowScale[300],
    "4": orangeScale[400],
    fail: redScale[500],
    "5": redScale[500],
    critical: redScale[700],
};
const baseColors = {
    transparent: "transparent",
    current: "currentColor",
    black,
    white,
    overlay,
    gray: grayScale,
    red: redScale,
    orange: orangeScale,
    yellow: yellowScale,
    teal: tealScale,
    blue: blueScale,
    lime: limeScale,
    green: greenScale,
    cyan: cyanScale,
    sky: skyScale,
    indigo: indigoScale,
    purple: purpleScale,
    pink: pinkScale,
    magenta: magentaScale,
    ["red-yellow"]: redYellowScale,
    ["purple-magenta"]: purpleMagentaScale,
    ["sky-teal"]: skyTealScale,
    ["sky-red"]: skyRedScale,
    ["indigo-magenta"]: indigoMagentaScale,
    ["teal-orange"]: tealOrangeScale,
    ["purple-teal"]: purpleTealScale,
    ["blue-steel"]: blueSteelScale,
    error: error,
    warning: warning,
    success: success,
    primary: primary,
    risk: riskColors,
    severity: severityColors,
    ["vis-a"]: visScaleA,
    ["vis-b"]: visScaleB,
    ["vis-c"]: visScaleC,
    ["vis-d"]: visScaleD,
    ["vis-e"]: visScaleE,
};
const iconColor = {
    gray: grayScale[400],
    red: redScale[400],
    orange: orangeScale[400],
    yellow: yellowScale[400],
    teal: tealScale[400],
    blue: blueScale[400],
    ["blue-steel"]: blueSteelScale[400],
};
const textColor = {
    default: grayScale[900],
    secondary: grayScale[600],
    disabled: grayScale[400],
    hint: grayScale[500],
    link: blueScale[600],
    ["dark-bg"]: {
        DEFAULT: white,
        secondary: grayScale[500],
        disabled: grayScale[600],
        hint: grayScale[400],
        link: blueScale[300],
        red: redScale[400],
        orange: orangeScale[300],
        yellow: yellowScale[300],
        teal: tealScale[300],
        blue: blueScale[300],
        ["blue-steel"]: blueSteelScale[300],
    },
    ...baseColors,
    risk: riskColors,
    icon: iconColor,
};
const navBackground = blueSteelScale[900];

export { baseColors, black, blueScale, blueSteelScale, cyanScale, error, grayScale, greenScale, iconColor, indigoMagentaScale, indigoScale, limeScale, magentaScale, navBackground, orangeScale, overlay, pinkScale, primary, purpleMagentaScale, purpleScale, purpleTealScale, redScale, redYellowScale, riskColors, severityColors, skyRedScale, skyScale, skyTealScale, success, tealOrangeScale, tealScale, textColor, visScaleA, visScaleB, visScaleC, visScaleD, visScaleE, warning, white, yellowScale };
//# sourceMappingURL=colors.esm.js.map
